import api from "./core";

const basePath = "api/{{serverSegment}}/VitalRecords";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(isClientId, id) {
    return api.post(
      `${basePath}`,
      isClientId
        ? {
            patientId: id
          }
        : {
            episodeOfCareId: id
          }
    );
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
